<style lang="scss">
.el-card__body:empty {
    display: none;
}
</style>
<style lang="scss" scoped>
.student-rules {
    &__header {
        height: 50px;
        @include flex-center;
        &__text {
            margin-left: 20px;
            width: 25%;
        }
    }
    &__text {
        padding: 20px;
        text-align: center;
    }
    &__col {
        width: 100%;
        padding-right: 20px;
        &:last-child {
            width: 50px;
            padding-right: 0;
        }
        .el-select {
            width: 100%;
        }
    }
    &__rules {
        margin-bottom: 10px;
        &__row {
            @include flex-center;
            margin-bottom: 10px;
            &__item {
                margin-right: 15px;
            }
        }
    }
}
</style>

<template lang="pug">
el-card.student-rules
    .clearfix(slot='header')
      .student-rules__header
        el-switch(v-model='active') 
        .student-rules__header__text Sync students
        el-alert(v-if='isDirty' type="error" center :closable="false") Some existing matches may be discarded when changing rules
    loading(v-if='$apollo.loading')
    template(v-else-if='active')
      .student-rules__text(v-if='!rules.length')
        el-button(type="primary", @click='add') Create custom rules
      template(v-else='')
        el-form(:inline='true')
          el-form-item(label='Manage accounts when ')
            el-select(v-model='ruleMatch', style='width:100px;')
              el-option(value='all', label='all')
              el-option(value='any', label='any')
          el-form-item(label='of the following rules are met:')
        .student-rules__rules(v-for='(rule, index) in rules')
          .student-rules__rules__row
            .student-rules__col
              el-select(v-model='rule.group', placeholder='Select').student-rules__rules__row__item
                el-option(v-for='item in types', :key='item.value', :label='item.label', :value='item.value')
            .student-rules__col
              el-select(v-model='rule.operator', placeholder='Select').student-rules__rules__row__item
                el-option(v-for='opp in operators', :key='opp', :label="opp.replace('_', ' ')", :value='ldash.camelCase(opp)')
            .student-rules__col
              el-select(v-model='rule.value')
                el-option(v-for='group in filteredGroups(rule.group)', :key='group.id', :label='group.name', :value='group.id')
            .student-rules__col
              el-button(type='danger', @click='remove(rule)', icon='fe fe-trash-2 fe-no-margin', plain='')
        el-button(v-if='active', icon='fe fe-plus fe-just-off', @click='add', type='primary') Create new rule
</template>
<script>
import _ from "lodash";
import gql from "graphql-tag";
export default {
    props: {
        rules_type: String,
    },
    data() {
        return {
            original: undefined,
            active: false,
            ruleMatch: "all",
            operators: ["is"],
            groups: null,
            types: [
                {
                    value: "registration",
                    label: "Registration"
                },
                {
                    value: "year",
                    label: "Year"
                },
                {
                    value: "house",
                    label: "House"
                },
                {
                    value: "class",
                    label: "Class"
                }
            ],
            ldash: _,
            loaded: false,
            calendarRules: [],
            studentRules: [],
        };
    },

    computed: {
        isDirty() {
            const calculated = {
                active: this.active,
                match: this.ruleMatch,
                rules: this.rules
            };

            return this.original && this.original.active && !_.isEqual(this.original, calculated);
        },
        rules() {
            return !this.rules_type ? this.studentRules : this.calendarRules;
        }
    },

    watch: {
        active() {
            this.update();
        },
        ruleMatch() {
            this.update();
        },
        rules: {
            deep: true,
            handler() {
                this.update();
            }
        }
    },

    apollo: {
        studentRules: {
            query: gql`
                {
                    Settings {
                        id
                        student_active
                        student_provision_rule_match
                        student_provision_rules {
                            group
                            operator
                            value
                        }
                    }
                }
            `,
            update(r) {
                if (!this.rules_type) {
                    this.original = _.cloneDeep({
                        active: r.Settings.student_active,
                        match: r.Settings.student_provision_rule_match,
                        rules: r.Settings.student_provision_rules
                    });

                    this.active = _.cloneDeep(r.Settings.student_active);
                    this.ruleMatch = _.cloneDeep(r.Settings.student_provision_rule_match);
                }
                this.loaded = true;
                return _.cloneDeep(r.Settings.student_provision_rules);
            }
        },
        calendarRules: {
            query: gql`
                {
                    Settings {
                        id
                        student_calendar_active
                        student_calendar_rule_match
                        student_calendar_rules {
                            group
                            operator
                            value
                        }
                    }
                }
            `,
            update(r) {
                if (this.rules_type == 'calendar') {
                    this.original = _.cloneDeep({
                        active: r.Settings.student_calendar_active,
                        match: r.Settings.student_calendar_rule_match,
                        rules: r.Settings.student_calendar_rules
                    });

                    this.active = _.cloneDeep(r.Settings.student_calendar_active);
                    this.ruleMatch = _.cloneDeep(r.Settings.student_calendar_rule_match);
                }
                return _.cloneDeep(r.Settings.student_calendar_rules);
            }
        },
        groups: {
            query: gql`
                {
                    Groups {
                        id
                        type
                        name
                    }
                }
            `,
            update: r => r.Groups
        }
    },

    methods: {
        update() {
            this.$emit("input", {
                active: this.active,
                match: this.ruleMatch,
                rules: _.map(this.rules, r => {
                    return _.pick(r, ["group", "operator", "value"]);
                })
            });
        },
        filteredGroups(type) {
            return _.filter(this.groups, { type });
        },
        add() {
            this.rules.push({ group: null, operator: "is", value: null });
        },
        remove(rule) {
            if (this.rules_type) {
                this.calendarRules = this.calendarRules.filter(r => r !== rule);
            } else {
                this.studentRules = this.studentRules.filter(r => r !== rule);
            }
        }
    }
};
</script>

